module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input-container hidden-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    ref: "search",
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": _vm.s__('ProjectsDropdown|Search your projects')
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.searchQuery) ? _c('i', {
    staticClass: "search-icon fa fa-fw fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f3261a1"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/search.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7f3261a1"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/search.vue
// module chunks = main